// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import type { ReactNode } from 'react';

export type PoliciesCardProps = Readonly<{
  /** Header title (e.g. "Policies requiring signature"). */
  title: string;
  /** Optional descriptive line under the title. */
  description?: string;
  /** Card content — typically a table of policies or a single-policy summary row. */
  children: ReactNode;
}>;

/**
 * Shared card wrapper used to render policy context on every advisor
 * compose surface. Replaces the three near-identical card shells the
 * legacy pages (WizardSendInvitationsPage, ResendInvitationPage,
 * CoAEmailCraftingStep) were each inlining. Works equally for a full
 * policy table (invitations) or a single-policy summary
 * (NudgeProviderPage).
 */
export function PoliciesCard({ title, description, children }: PoliciesCardProps) {
  return (
    <div className="bg-white rounded-card shadow-[0_0_10px_0_rgba(0,0,0,0.10)] mx-lg mt-lg overflow-hidden">
      <div className="px-5 py-3 border-b border-lilac-04">
        <h3 className="text-base font-semibold text-black !m-0">{title}</h3>
        {description && (
          <p className="text-xs text-grey-02 mt-0.5 !mb-0">{description}</p>
        )}
      </div>
      {children}
    </div>
  );
}

export default PoliciesCard;
